import { useFormContext, useFormState, useWatch } from "react-hook-form";

import { RenderElement } from "@up/form";

export function WhyApplying() {
  const KEY = "why-applying";
  const VALIDATION = {
    presence: true,
    minLength: 50,
  };
  const LABEL = "Briefly tell us why you want to participate in the program.";
  const HELP_TEXT =
    "We want to learn more about you and what makes you a great fit. We are looking for motivation, curiosity, and passion for the subject matter rather than perfect writing.";

  const { control, register } = useFormContext();
  const { errors } = useFormState();
  const formValues = useWatch();

  return (
    <RenderElement
      control={control}
      element={{
        type: "textarea",
        name: KEY,
        label: LABEL,
        helpText: HELP_TEXT,
        validate: VALIDATION,
      }}
      errors={errors}
      formValues={formValues}
      register={register}
      wrapperProps={{ className: "mb-8" }}
    />
  );
}
